module.exports = __webpack_public_path__ + "img/logosmep@2x.8f428303.png";